"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductsServiceCallList;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _queryBuilder = _interopRequireDefault(require("@sprinx/query-builder"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

function useServiceCallList(options, serviceName, initialFilter, initialOrder, initialPagination) {
  return (0, _useServiceCall.default)((0, _extends2.default)({
    // zavolaj sluzbu len v pripade, ze mame nejake inicialne nastavenia,
    // v opacnom pripade cakaj na externe volanie.
    initialArgs: initialFilter || initialOrder || initialPagination ? [initialFilter, initialOrder, initialPagination] : undefined,
    defaultResult: {
      rows: [],
      total: 0,
      page: (initialPagination || {}).page || 1,
      pageSize: (initialPagination || {}).rowsPerPage || 10,
      totalPages: 1
    }
  }, options), /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(client, filter, order, pagination) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", client.call(serviceName, (0, _queryBuilder.default)(null, filter, order, pagination), {
                method: 'post'
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }());
}

function useProductsServiceCallList(options, initialFilter, initialOrder, initialPagination) {
  // const { clientCode, serviceNames } = useProductsContext();
  return useServiceCallList((0, _useDefaults.default)(options, {
    clientCode: 'api'
  }), (0, _useResolveServiceActionName.default)(null, 'v1.products.list'
  /* , serviceNames */
  ), initialFilter, initialOrder, initialPagination);
}